/** Accreditation Form "Fill from registration address" checkbox and the delivery fields it fills. */
const FILL_CHECKBOX_KEY = 'sameAsOtherAddress';
const FILLED_FIELD_KEYS = ['street', 'deliveryCity', 'state', 'country', 'deliveryPostcode'];

/**
 * Empty the delivery fields when the user unticks the checkbox. Their schema calculateValue
 * (`... ? copiedValue : value`) keeps the current value while the box is off, which is also what
 * preserves a hand-typed address, so the clear has to happen once, on the untick itself.
 * Pass the `flags` from a Form.io change event: Form.io debounces change events, and
 * `flags.changes` lists every change in that window, while `changed` holds only the last one.
 */
export function clearFillFromRegAddressOnUncheck(flags) {
  const untick = flags?.changes?.find(
    (change) =>
      change.component?.key === FILL_CHECKBOX_KEY &&
      change.value === false &&
      !change.flags?.fromSubmission
  );
  const webform = untick?.instance?.root;
  if (typeof webform?.getComponent !== 'function') return;

  FILLED_FIELD_KEYS.forEach((key) => {
    const field = webform.getComponent(key);
    field?.setValue(field.emptyValue);
  });
}
